import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { Params } from '@angular/router';

interface SuggestionConfig {
  metricId: string;
  id: string;
  type: string;
}

@Component({
  selector: 'info-list-item',
  templateUrl: './info-list-item.html',
  styleUrls: ['./info-list-item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoListItemComponent {
  Array: typeof Array = Array;

  @ContentChild('value') private _valueContent: ElementRef;

  @Input() public show: boolean = true;

  @Input() public showIfNoValue: boolean = false;

  @Input() public lock: boolean = false;

  @Input() public label: string;
  @Input() public value: string | string[];

  @Input() public valueIcon: string;

  @Input() public valueIconSize: string;

  @Input() public labelTooltip: string;

  @Input() public valueTooltip: string;

  @Input() public suggestionConfig: SuggestionConfig;

  @Input() public link: string | string[];
  @Input() public linkParams: Params;

  @Input() public enableInteract: boolean = true;
  @Output() public interact: EventEmitter<string> = new EventEmitter<string>();

  @Input() public enableLabelInteract: boolean = true;
  @Output() public labelInteract: EventEmitter<string> =
    new EventEmitter<string>();

  get isAbsoluteLink(): boolean {
    return (
      this.link &&
      !Array.isArray(this.link) &&
      this.link.match(/(?:^[a-z][a-z0-9+.-]*:|\/\/)/i) != null
    );
  }

  get isValid(): boolean {
    if (!this.show) return false;
    if (this._valueContent) return true;
    if (this.lock) return true;

    if (this.showIfNoValue) return true;

    if (Array.isArray(this.value)) {
      return this.value.length > 0;
    } else {
      return !!this.value;
    }
  }

  constructor() {}
}
